"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var LeftMenu_1 = require("./LeftMenu");
var Logo_1 = require("./Logo");
var RightMenu_1 = require("./RightMenu");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var defaultPages = ['games', 'promotions', 'payments', 'tournaments', 'vip'];
var HeaderWithCashback = function (_a) {
    var isNotFoundPage = _a.isNotFoundPage, languages = _a.languages, _b = _a.pages, pages = _b === void 0 ? defaultPages : _b, promoLink = _a.promoLink, _c = _a.isHavePadding, isHavePadding = _c === void 0 ? false : _c, searchRightMobile = _a.searchRightMobile, additionalPages = _a.additionalPages, _d = _a.showSignUp, showSignUp = _d === void 0 ? true : _d;
    var pathname = (0, navigation_1.usePathname)();
    var headerRef = (0, react_1.useRef)(null);
    if (pathname.includes('game-not-available')) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // useEffect(() => {
    //   if (headerRef.current && isHavePadding) {
    //     document.body.style.marginTop = headerRef.current.clientHeight + 'px'
    //   }
    // }, [headerRef?.current])
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("header", { id: "header", className: styles_module_scss_1.default.header, ref: headerRef },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                    react_1.default.createElement(LeftMenu_1.LeftMenu, { isNotFoundPage: isNotFoundPage, pages: pages, promoLink: promoLink, searchRightMobile: searchRightMobile, additionalPages: additionalPages }),
                    react_1.default.createElement(Logo_1.Logo, null),
                    react_1.default.createElement(RightMenu_1.RightMenu, { isNotFoundPage: isNotFoundPage, languages: languages, searchRightMobile: searchRightMobile, showSignUp: showSignUp }))))));
};
exports.default = react_1.default.memo(HeaderWithCashback);
